<!--
 * @Author: Shber
 * @Date: 2023-04-19 15:59:06
 * @LastEditors: Shber
 * @LastEditTime: 2023-05-29 18:51:43
 * @Description:
-->
<template>
  <div class="user_bar">
    <a class="bar_left" :href="user.link">
      <div class="bar_user">
        <img :src="user.usr_pic" class="user_pic" alt="">
        <img v-if="user.auth_pic" :src="user.auth_pic" class="auth_icon" alt="">
      </div>
      <div class="user_text">
        <p class="title fw_bold text_over">{{ user.nick_name }}</p>
        <p class="text_over"><span>{{ user.unit_duty }}</span></p>
      </div>
    </a>
    <div v-if="user.follow_status == 1" class="bar_right fw_bold active" title="已关注" @click="followDel"> {{ $t('bigEvent.info.text6_1') }} </div>
    <div v-else-if="user.follow_status == 2" class="bar_right fw_bold active" title="互相关注" @click="followDel"> {{ $t('bigEvent.info.text6_2') }}  </div>
    <div v-else class="bar_right fw_bold" title="关注" @click="followAdd">
      <i class="icon_add" /> {{ $t('bigEvent.info.text6') }}</div>
  </div>
</template>
<script setup>
import { defineProps, watch, reactive } from 'vue'
import { checkloginCallback } from '@/utils'
import { ajaxHttp } from '@/api/api.js'
import { Toast } from 'vant'

const props = defineProps({
  userInfo: { // 用户信息
    type: Object,
    default: () => {}
  }
})
let user = reactive({})

watch(() => props.userInfo
  , (newVal, oldVal) => {
    console.log('userBar', newVal)
    user = newVal
  }, { immediate: true })

const followAdd = () => {
  checkloginCallback(
    function() {
      ajaxHttp.followAdd({ follow_user_id: user.skuid }).then(res => {
        if (res.code === 1) {
          user.follow_status = res.data.follow_status
        } else { Toast(res.message) }
      })
    }
  )
}
const followDel = () => {
  checkloginCallback(
    function() {
      ajaxHttp.followDel({ follow_user_id: user.skuid }).then(res => {
        if (res.code === 1) {
          user.follow_status = res.data.follow_status
        } else { Toast(res.message) }
      })
    }
  )
}
</script>

<style lang="scss" scoped>
.user_bar{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0px;
  .bar_left{
    display: flex; justify-items: center; align-items: center;
    .bar_user{
      width: 48px; height: 48px; position: relative; margin-right: 12px;
      .auth_icon, .user_pic{border-radius: 50%;}
      .user_pic{width: 46px; height: 46px; border: 1px solid #e5e5e5; }
      .auth_icon{width: 12px; height: 12px;
        position: absolute; bottom: 2px; right: 3px; z-index: 3;
      }
    }
    .user_text{
      width: 190px;
      .title{font-size: 16px; line-height: 20px;  color: #333333; margin-bottom: 2px;}
      span{font-size: 12px; line-height: 17px; color: #999999;}
    }
  }
  .bar_right{
    display: flex; align-items: center;
    .icon_add{
      display: block; width: 16px; height: 16px; margin-right: 2px;
      background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M7.99998 3.33334V12.6667M3.33331 8H12.6666' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E ");
      background-repeat: no-repeat; background-position: center;
    }
    font-size: 14px; line-height: 14px; color: #fff; background: #C99700; border-radius: 2px; padding: 9px 16px 9px 9px;
  }
  .active{
    color: #fff;
    padding: 9px;
    background-color: #D5D5D5;
  }

}
</style>
